import { RadioButton } from "primereact/radiobutton"
import styles from "../../../../../styles/Participant-Employment.module.css"
const PastEducationExperiencesRadioBtn = ({
  label,
  valueName,
  setValue,
  disabled,
  value,
  callback,
}) => {
  return (
    <div className={styles.field}>
      <label className={styles.label} style={{ marginBottom: "5px" }}>
        {label}
      </label>
      <div className={styles.radio_btn_wrapper}>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`Okay_${label}`}
            value={"Okay"}
            style={{ margin: "0" }}
            onChange={(e) => {
              valueName ? setValue(valueName, e.value) : setValue(e.value)
              if (callback) {
                callback()
              }
            }}
            disabled={disabled}
            checked={value === "Okay"}
          />
          <label htmlFor={`Okay_${label}`} className={styles.inline_label}>
            Okay
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`Problem_${label}`}
            value={"Problem"}
            style={{ margin: "0" }}
            onChange={(e) => {
              valueName ? setValue(valueName, e.value) : setValue(e.value)
              if (callback) {
                callback()
              }
            }}
            disabled={disabled}
            checked={value === "Problem"}
          />
          <label htmlFor={`Problem_${label}`} className={styles.inline_label}>
            Problem
          </label>
        </div>
      </div>
    </div>
  )
}
export default PastEducationExperiencesRadioBtn
